import _ from 'lodash';
import moment from 'moment';
import { types as Actions } from '../../actions/activitylog/activitylog-action';

const initialState = {
  loading: false,
  logs: [],
  error: null,
};
export default function (state = initialState, action) {
  switch (action.type) {
    case Actions.ACTIVITY_LOG_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Actions.ACTIVITY_LOG_SUCCESS:
      let list = action.payload?.data || [];
      const logs = [];

      if (list?.length) {
        list =
          _.groupBy(list, (a) => {
            return moment(a.actionTime).format('DD/MM/YYYY');
          }) || '';

        list = _.values(list);

        list?.map((item) => {
          logs.push({
            date: moment(item[0]?.actionTime).format('MM/DD/YYYY'),
            day: moment(item[0]?.actionTime).format('ddd'),
            logs: item,
          });
        });
      }
      const lastLog = logs[logs?.length - 1] || '';
      if (lastLog && lastLog.date) {
        if (lastLog.date === moment().format('MM/DD/YYYY')) {
          logs[logs.length - 1] = {
            ...lastLog,
            date: 'Today',
          };
        }
      }

      return {
        ...state,
        logs: logs || [],
      };
    case Actions.ACTIVITY_LOG_FAIL:
      return {
        ...state,
        error: action.payload.data,
      };

    default:
      return state;
  }
}
